import { Component } from '@angular/core';
import { Validators } from '@angular/forms';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  length = 0;
  includeLetters = false;
  includeNumbers = false;
  includeSymbols = false;
  password = '';

  onChangeLength(value: string) {
    const parsedValue = parseInt(value);

    if (!isNaN(parsedValue)) {
      this.length = parsedValue;
    }
  }

  onChangeUseLetters() {
    this.includeLetters = !this.includeLetters;
  }

  onChangeUseNumbers() {
    this.includeNumbers = !this.includeNumbers;
  }

  onChangeUseSymbols() {
    this.includeSymbols = !this.includeSymbols;
  }

  onButtonClick() {
    const numbers = '12354667680'
    const letters = 'abcadfjdkfuituiejrie';
    const symbols = '@#@$#$^%&^*^&*()';

    let validChars = '';

    if (this.includeLetters) {
      validChars += letters;
    }

    console.log(validChars + 'number: ' + this.length);

    if (this.includeNumbers) {
      validChars += numbers;
    }

    if (this.includeSymbols) {
      validChars += symbols;
    }
   
    let genertatedpassword = '';
    for (let i = 0; i < this.length; i++){
      const index = Math.floor(Math.random() * validChars.length);
      genertatedpassword += validChars[index];
    }

    this.password = genertatedpassword;
  }
}
